// extracted by mini-css-extract-plugin
export default {"modal":"DealAssociation_modal__V0Yl3","modalTitle":"DealAssociation_modalTitle__ATaai","titleSubText":"DealAssociation_titleSubText__zVRmh"};